import { render, staticRenderFns } from "./EnviarImagem.vue?vue&type=template&id=5aaa58c5&"
import script from "./EnviarImagem.vue?vue&type=script&lang=js&"
export * from "./EnviarImagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EnviarImagem.vue"
export default component.exports